/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { getCookie, setCookie } from "@/utils/cookies";
import { getElements } from "@/utils/dom/element";

function generateFormKey() {
    const allowedCharacters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        charactersLength = allowedCharacters.length,
        length = 16;

    let formKey = '';

    for (let i = 0; i < length; i++) {
        formKey += allowedCharacters[Math.round(Math.random() * (charactersLength - 1))];
    }

    return formKey;
}

export function getFormKey() {
    let formKey = getCookie('form_key');

    if (!formKey) {
        formKey = generateFormKey();
        setCookie('form_key', formKey)
    }

    return formKey;
}

export function initFormKey() {
    const formKey = getFormKey();

    getElements<HTMLInputElement>('input[name="form_key"]').forEach(input => input.value = formKey);
}
